import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useEffect, useRef } from 'react';
import { VerifiedStoreIcon, ScriptPrint } from '@ads-placements-frontend/commons';
import Card, { CardContent } from '@andes/card';
import Typography from '@andes/typography';
import Image from 'frontend-image';
import clsx from 'classnames';
import CarouselFree, { CarouselFreeSlide } from '@andes/carousel-free';
import Button from '@andes/button';
import MoneyAmount from '@andes/money-amount';
import { CarouselSnapped, CarouselSnappedSlide } from '@andes/carousel-snapped';
const mainNamespace = 'brand-wrapper-showroom';
const mainNamespaceDesktop = `${mainNamespace}-desktop`;
const mainNamespaceMobile = `${mainNamespace}-mobile`;
const namespace$7 = `${mainNamespaceMobile}-hero`;
const Hero$1 = props => {
  const {
    items,
    lowEnd
  } = props;
  const [{
    event_tracking: {
      click
    },
    content: {
      images,
      texts
    }
  }] = items;
  const [url] = click;
  return jsxs("div", {
    className: namespace$7,
    children: [jsx("a", {
      href: url.url,
      className: `${namespace$7}-main-logo-container`,
      children: jsx(Image, {
        className: `${namespace$7}-main-logo`,
        preload: true,
        src: images.primary_logo,
        alt: "",
        lowEnd: lowEnd,
        lazyload: "off",
        width: 80,
        height: 80
      })
    }), jsx(Typography, {
      size: 's',
      className: `${namespace$7}-primary-title`,
      component: "h3",
      children: texts.primary_title
    })]
  });
};
const IconChevron = () => jsx("svg", {
  width: "7",
  height: "9",
  viewBox: "0 0 7 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    // eslint-disable-next-line max-len
    d: "M0.950035 0.900286L4.54642 4.49667L0.946289 8.09681L1.79482 8.94534L6.24348 4.49667L1.79856 0.0517578L0.950035 0.900286Z",
    fill: "#3483FA"
  })
});
const BrandCta = props => {
  const {
    items,
    className,
    isMobile
  } = props;
  const [{
    event_tracking: {
      click
    },
    content: {
      is_verified_store: isVerifiedStore,
      texts
    }
  }] = items;
  const [url] = click;
  const namespace = `${isMobile ? mainNamespaceMobile : mainNamespaceDesktop}-brand-cta`;
  return jsxs("a", {
    href: url.url,
    className: clsx(namespace, className),
    children: [isVerifiedStore && jsx(VerifiedStoreIcon, {
      size: isMobile ? 10 : 14
    }), jsx(Typography, {
      className: `${namespace}-typography`,
      size: 'xs',
      color: "link",
      children: texts.cta
    }), jsx("div", {
      className: `${namespace}-chevron`,
      children: jsx(IconChevron, {})
    })]
  });
};
const namespace$6 = `${mainNamespaceMobile}-footer`;
const Footer = props => {
  const {
    items
  } = props;
  const [{
    content: {
      texts
    }
  }] = items;
  return jsxs("div", {
    className: namespace$6,
    children: [jsx(BrandCta, _objectSpread(_objectSpread({}, props), {}, {
      className: `${namespace$6}-brand-cta`,
      isMobile: true
    })), jsx(Typography, {
      className: `${namespace$6}-promoted-typography`,
      color: "secondary",
      size: 's',
      component: "h2",
      children: texts.promoted
    })]
  });
};
const namespace$5 = 'icon-meli-choice';
const IconMeliChoice = _ref => {
  let {
    className,
    size
  } = _ref;
  return jsxs("svg", {
    className: clsx(namespace$5, className),
    xmlns: "http://www.w3.org/2000/svg",
    width: size.width,
    height: size.height,
    fill: "none",
    viewBox: `0 0 ${size.width} ${size.height}`,
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0214 6.17386C18.0214 3.08276 13.9874 0.562946 9.01101 0.562946C4.03492 0.562946 0.00103839 3.08276 0.00103839 6.17386C0.00103839 6.25369 0 6.4744 0 6.50232C0 9.78151 3.52585 12.4375 9.00984 12.4375C14.5278 12.4375 18.0214 9.78225 18.0214 6.50294V6.17386Z",
      fill: "white"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.01266 11.4453C4.22789 11.4453 0.349121 9.08293 0.349121 6.16879C0.349121 3.2544 4.22789 0.891898 9.01266 0.891898C13.7976 0.891898 17.6763 3.2544 17.6763 6.16879C17.6763 9.08293 13.7976 11.4453 9.01266 11.4453Z",
      fill: "#00A650"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.1358 4.50681C6.13125 4.51509 6.04481 4.60023 6.10088 4.66869C6.23769 4.8349 6.65992 4.9303 7.08696 4.8391C7.34124 4.78473 7.66703 4.53795 7.98283 4.29945C8.32498 4.04068 8.66428 3.78155 9.00565 3.67848C9.36688 3.569 9.59831 3.61596 9.75134 3.65995C9.91917 3.70765 10.1163 3.81281 10.4311 4.03759C11.024 4.46195 13.4076 6.44273 13.8195 6.78516C14.1511 6.64255 15.6254 6.03839 17.6286 5.61799C17.4546 4.60122 16.805 3.67095 15.8197 2.90923C14.4465 3.4584 12.7682 3.74484 11.1273 2.98177C11.1189 2.97856 10.2307 2.57842 9.35467 2.59807C8.05266 2.62674 7.48856 3.1633 6.89174 3.73125L6.1358 4.50681Z",
      fill: "white"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7226 6.99985C13.6947 6.97624 10.9198 4.66465 10.2911 4.21472C9.92739 3.95496 9.72504 3.88873 9.51256 3.8629C9.40197 3.84931 9.2492 3.86883 9.14237 3.89676C8.84993 3.97251 8.46755 4.21595 8.128 4.47212C7.7765 4.73867 7.44512 4.98965 7.13776 5.05527C6.74473 5.13906 6.265 5.0402 6.04603 4.8992C5.95724 4.84248 5.89494 4.77686 5.86483 4.71013C5.78409 4.53156 5.93323 4.38883 5.95763 4.36498L6.72344 3.57645C6.81236 3.4918 6.90218 3.40728 6.99381 3.32386C6.74668 3.35451 6.51836 3.41457 6.29602 3.47351C6.01851 3.54778 5.75164 3.61847 5.48179 3.61834C5.36913 3.61834 4.76517 3.52406 4.65056 3.4944C3.95757 3.31385 3.34946 3.13801 2.441 2.73417C1.35238 3.50577 0.624336 4.47039 0.414062 5.53301C0.57047 5.57231 0.822539 5.64373 0.928455 5.6661C3.3919 6.18759 4.15914 6.72477 4.29829 6.83697C4.44898 6.67731 4.6664 6.57623 4.90899 6.57623C5.1817 6.5766 5.42715 6.70697 5.57654 6.90852C5.71763 6.80237 5.9122 6.71179 6.16375 6.71192C6.27798 6.71192 6.39635 6.73206 6.51603 6.77074C6.79405 6.86157 6.93748 7.03778 7.01173 7.19719C7.10505 7.15703 7.21966 7.1275 7.35465 7.12787C7.48731 7.12787 7.62529 7.15679 7.7643 7.21388C8.21859 7.39949 8.28934 7.82421 8.24806 8.14452C8.28038 8.14081 8.31296 8.13945 8.34606 8.13945C8.88459 8.13982 9.32266 8.55652 9.3224 9.06948C9.3224 9.22815 9.2797 9.37743 9.20558 9.50854C9.35213 9.58701 9.72569 9.76434 10.0536 9.72479C10.3156 9.69341 10.4152 9.60802 10.4507 9.56019C10.475 9.52707 10.501 9.48864 10.477 9.46096L9.78189 8.72582C9.78189 8.72582 9.66741 8.62275 9.70518 8.58309C9.74451 8.54218 9.81512 8.60076 9.86509 8.64055C10.2189 8.92193 10.6509 9.34628 10.6509 9.34628C10.6582 9.35086 10.6867 9.40474 10.8465 9.43205C10.984 9.4554 11.2272 9.44181 11.3958 9.30995C11.4384 9.27671 11.4808 9.23519 11.5164 9.19231C11.5135 9.19441 11.5113 9.19725 11.5086 9.19824C11.6863 8.98174 11.489 8.76264 11.489 8.76264L10.6775 7.89502C10.6775 7.89502 10.5615 7.79295 10.6008 7.7518C10.6362 7.71621 10.7109 7.76996 10.7616 7.81025C11.0186 8.01477 11.3817 8.36164 11.7296 8.68615C11.7975 8.73335 12.1033 8.91353 12.5083 8.66032C12.7539 8.50684 12.8033 8.31839 12.7963 8.17615C12.7792 7.98783 12.625 7.85375 12.625 7.85375L11.5164 6.79273C11.5164 6.79273 11.3994 6.69758 11.4407 6.64939C11.4746 6.60885 11.5507 6.66731 11.6004 6.70697C11.9537 6.98823 12.9095 7.82261 12.9095 7.82261C12.9231 7.83175 13.2535 8.05567 13.6616 7.80827C13.8075 7.71942 13.9008 7.58547 13.9088 7.43001C13.9227 7.16012 13.7226 6.99985 13.7226 6.99985Z",
      fill: "white"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.34603 8.34529C8.17418 8.34331 7.98623 8.44057 7.9617 8.42635C7.94807 8.41783 7.97221 8.35209 7.98817 8.31415C8.00479 8.27646 8.23116 7.62806 7.67925 7.40291C7.25715 7.23015 6.99898 7.42453 6.9102 7.51227C6.88696 7.53513 6.87658 7.5334 6.87398 7.50399C6.86542 7.38734 6.81051 7.07136 6.44604 6.96558C5.92529 6.8137 5.5904 7.15984 5.50539 7.28477C5.46736 7.00215 5.21646 6.78269 4.90909 6.78256C4.57512 6.78219 4.30423 7.03984 4.30371 7.35768C4.30371 7.67551 4.57434 7.93329 4.90831 7.93329C5.07069 7.93366 5.21775 7.87187 5.32626 7.77264C5.32977 7.77573 5.33107 7.78117 5.32938 7.79204C5.30407 7.9344 5.25708 8.45169 5.82612 8.66226C6.0543 8.74666 6.24835 8.68388 6.4093 8.5765C6.45707 8.54424 6.46499 8.55796 6.45811 8.60072C6.4376 8.73381 6.46356 9.01865 6.88307 9.18066C7.20224 9.30411 7.3911 9.17769 7.5148 9.06882C7.56867 9.02211 7.58333 9.02965 7.58619 9.10194C7.60138 9.48687 7.93729 9.7926 8.34512 9.79297C8.76554 9.79334 9.10613 9.46982 9.10626 9.06981C9.10665 8.66967 8.76619 8.34961 8.34603 8.34529Z",
      fill: "white"
    }), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.34606 9.7416C7.9651 9.74123 7.65553 9.45947 7.64151 9.10037C7.64047 9.0696 7.63723 8.98767 7.56454 8.98767C7.53469 8.98767 7.5086 9.00484 7.47861 9.03055C7.39502 9.10444 7.28833 9.17958 7.13244 9.17958C7.06183 9.17958 6.98525 9.16388 6.90438 9.13237C6.50214 8.97729 6.49656 8.71432 6.51291 8.60854C6.51745 8.58036 6.51888 8.55095 6.4985 8.52821L6.47371 8.50708H6.44866C6.42828 8.50708 6.40713 8.51499 6.3787 8.53415C6.2624 8.61187 6.15077 8.64969 6.03733 8.64969C5.9749 8.64969 5.91078 8.6377 5.84679 8.61422C5.31708 8.41799 5.35887 7.9421 5.38483 7.79888C5.3886 7.76996 5.38107 7.74735 5.36173 7.73239L5.32435 7.70311L5.28943 7.73499C5.18611 7.82965 5.05125 7.88155 4.90925 7.88155C4.60591 7.88118 4.35916 7.64663 4.35929 7.35784C4.35955 7.06892 4.60656 6.8345 4.9099 6.83487C5.18403 6.83487 5.41741 7.03098 5.45233 7.29172L5.47128 7.43235L5.5524 7.31335C5.56149 7.29939 5.7837 6.97945 6.19218 6.97982C6.26993 6.97982 6.35027 6.99181 6.43101 7.01554C6.75667 7.11019 6.81184 7.39133 6.82041 7.50848C6.82612 7.57669 6.87713 7.58002 6.88712 7.58002C6.91529 7.58002 6.93593 7.56297 6.95072 7.54839C7.01212 7.48734 7.14594 7.38577 7.35543 7.38577C7.45136 7.38601 7.55338 7.40764 7.65864 7.45077C8.17628 7.6622 7.94148 8.28836 7.93862 8.29491C7.89423 8.39871 7.89241 8.44455 7.93421 8.471L7.95459 8.48027H7.96977C7.99314 8.48027 8.02208 8.47063 8.06998 8.45518C8.14059 8.43195 8.24676 8.3971 8.34619 8.39735C8.73584 8.4013 9.05307 8.70332 9.05294 9.06997C9.05255 9.44044 8.73545 9.7416 8.34606 9.7416ZM13.8301 6.72365C12.9755 6.01347 10.9999 4.37845 10.4649 3.99611C10.1592 3.77713 9.95076 3.66159 9.76774 3.60969C9.68558 3.58596 9.57175 3.55915 9.4252 3.55902C9.28918 3.55902 9.14302 3.58238 8.99038 3.6286C8.6446 3.73277 8.30011 3.99339 7.96692 4.24548L7.94978 4.25846C7.63943 4.49325 7.3187 4.73632 7.07598 4.78797C6.96993 4.81071 6.86103 4.82233 6.75239 4.82233C6.48046 4.82196 6.23618 4.74732 6.14467 4.63622C6.12962 4.61781 6.13935 4.58803 6.17466 4.54515L6.17933 4.53947L6.93125 3.76799C7.52015 3.20733 8.07647 2.67793 9.35706 2.64988C9.37809 2.64926 9.39976 2.64889 9.42092 2.64889C10.2179 2.64939 11.0147 2.9891 11.1041 3.02852C11.8514 3.37551 12.6228 3.55186 13.3982 3.55247C14.2065 3.55272 15.0403 3.36229 15.917 2.97797C15.8191 2.8995 15.7172 2.82326 15.6123 2.74837C14.8421 3.06621 14.1083 3.22685 13.4004 3.22661C12.6774 3.22599 11.9548 3.06077 11.2535 2.7349C11.2166 2.7181 10.3366 2.32315 9.42131 2.32278C9.3973 2.32278 9.37302 2.32315 9.34901 2.32352C8.27337 2.3475 7.6676 2.71105 7.26016 3.02975C6.86389 3.0389 6.52213 3.12985 6.21788 3.21067C5.94647 3.28246 5.71218 3.34474 5.48348 3.34462C5.38925 3.34462 5.21986 3.33646 5.20454 3.33597C4.9417 3.32843 3.6171 3.01912 2.56353 2.63926C2.45606 2.71179 2.35261 2.78668 2.25175 2.86293C3.35244 3.29247 4.69184 3.62489 5.11459 3.65084C5.23219 3.65813 5.35757 3.67086 5.48283 3.67111C5.76255 3.67111 6.04161 3.59634 6.31172 3.52442C6.47125 3.48179 6.64738 3.43545 6.83248 3.40159C6.78302 3.44781 6.7337 3.49464 6.68425 3.54185L5.92025 4.32865C5.86015 4.38648 5.72958 4.5407 5.81563 4.73064C5.8499 4.80725 5.91934 4.88053 6.01656 4.94294C6.19867 5.05959 6.52459 5.13856 6.82741 5.1388C6.94216 5.13893 7.05093 5.12793 7.15087 5.10655C7.47109 5.03809 7.807 4.7834 8.16291 4.51401C8.44639 4.29961 8.84929 4.02725 9.15769 3.94717C9.24388 3.92493 9.34979 3.91096 9.43481 3.91096C9.46025 3.91121 9.48426 3.91195 9.50659 3.91504C9.71037 3.93963 9.90741 4.00562 10.2592 4.25697C10.8862 4.70543 13.6614 7.01677 13.6886 7.03963C13.6904 7.04099 13.8674 7.18632 13.8551 7.4279C13.8485 7.5626 13.77 7.68235 13.6334 7.76526C13.515 7.83681 13.3926 7.87327 13.2691 7.87327C13.0837 7.8729 12.9559 7.79023 12.9477 7.78454C12.9374 7.77663 11.9865 6.94658 11.6368 6.6678C11.581 6.62393 11.5269 6.58426 11.4721 6.58426C11.4429 6.58401 11.4171 6.596 11.3996 6.61688C11.3444 6.68139 11.4062 6.77086 11.4787 6.8298L12.5894 7.89255C12.5894 7.89255 12.7278 8.01587 12.7429 8.17887C12.7516 8.35509 12.663 8.50251 12.4791 8.61719C12.3481 8.69937 12.2154 8.74113 12.0854 8.74113C11.915 8.74113 11.7952 8.66724 11.7687 8.64969L11.6093 8.50016C11.3182 8.22743 11.0176 7.94544 10.7974 7.77058C10.7438 7.72807 10.6865 7.68889 10.6319 7.68889C10.6049 7.68889 10.5805 7.69841 10.562 7.71707C10.5368 7.74364 10.5194 7.79146 10.5818 7.87055C10.6077 7.90317 10.638 7.93011 10.638 7.93011L11.4485 8.79674C11.4553 8.80453 11.6156 8.98594 11.4667 9.1666L11.4381 9.2012C11.4138 9.22666 11.3876 9.25002 11.3628 9.27041C11.2245 9.37841 11.0398 9.3899 10.9667 9.3899C10.9276 9.3899 10.8899 9.38669 10.8571 9.381C10.7772 9.36741 10.7234 9.34616 10.6975 9.31687L10.6878 9.30711C10.6434 9.26361 10.2348 8.86656 9.89676 8.59791C9.85224 8.56232 9.79669 8.51759 9.73919 8.51759C9.71076 8.51759 9.68558 8.52821 9.66598 8.54873C9.59913 8.61842 9.69947 8.72272 9.74204 8.76091L10.4335 9.48666C10.4327 9.49309 10.4239 9.50804 10.4071 9.53102C10.3825 9.56365 10.2985 9.64348 10.0478 9.67338C10.0177 9.67721 9.98671 9.6787 9.95608 9.6787C9.69752 9.6787 9.4217 9.5592 9.27957 9.4874C9.34421 9.3574 9.37783 9.21405 9.37783 9.07034C9.37809 8.52871 8.916 8.08804 8.3471 8.08767C8.3349 8.08767 8.32192 8.08804 8.30984 8.08841C8.32841 7.84114 8.2918 7.37279 7.78689 7.16667C7.64151 7.10686 7.49666 7.07633 7.35569 7.07633C7.2455 7.07633 7.13945 7.09425 7.03976 7.13071C6.93515 6.93719 6.76148 6.79619 6.53485 6.72266C6.40972 6.68139 6.28512 6.6605 6.16479 6.6605C5.95465 6.6605 5.76112 6.71945 5.58849 6.83635C5.42299 6.64049 5.17326 6.52457 4.91016 6.52457C4.6799 6.52457 4.45846 6.61231 4.29439 6.76703C4.07919 6.61058 3.22563 6.09428 0.941305 5.60048C0.830587 5.57675 0.576701 5.5073 0.421202 5.46405C0.395372 5.58182 0.375643 5.70082 0.362793 5.82081C0.362793 5.82081 0.784119 5.91695 0.866931 5.93463C3.20058 6.42818 3.97171 6.94127 4.10203 7.03827C4.0579 7.13911 4.03493 7.2481 4.0348 7.35784C4.03441 7.81679 4.42653 8.19061 4.90912 8.19098C4.96312 8.19098 5.01672 8.18653 5.06942 8.17726C5.14198 8.51499 5.37419 8.77104 5.72906 8.90252C5.83277 8.94046 5.93764 8.95999 6.04057 8.95999C6.10729 8.96011 6.17427 8.95208 6.23982 8.93614C6.30523 9.09468 6.45269 9.29215 6.78237 9.41968C6.89789 9.46392 7.01342 9.48703 7.12582 9.48703C7.21759 9.48703 7.30728 9.47171 7.39282 9.4418C7.55078 9.80808 7.92681 10.0508 8.34593 10.0508C8.62357 10.0512 8.8903 9.94339 9.08474 9.75284C9.25127 9.84095 9.60264 10.0004 9.95777 10.0009C10.0037 10.0009 10.0468 9.99764 10.0899 9.99282C10.4426 9.95031 10.6068 9.81908 10.6822 9.717C10.6957 9.69921 10.708 9.6803 10.7184 9.66065C10.8016 9.68339 10.8932 9.70205 10.998 9.7023C11.1907 9.7023 11.3754 9.63977 11.5623 9.51014C11.7459 9.38409 11.8763 9.2033 11.895 9.04921C11.8954 9.04723 11.8958 9.04488 11.8961 9.04266C11.958 9.05477 12.0214 9.06107 12.0848 9.06107C12.2831 9.06107 12.4781 9.00225 12.6645 8.88596C13.024 8.66155 13.0864 8.36856 13.0805 8.17664C13.1433 8.18913 13.2077 8.19555 13.2715 8.19555C13.4577 8.19555 13.6404 8.14229 13.8146 8.03651C14.0375 7.90095 14.1716 7.69334 14.1919 7.45175C14.2058 7.28752 14.1631 7.12181 14.0721 6.97933C14.6744 6.7323 16.051 6.25419 17.672 5.90645C17.6622 5.78671 17.6441 5.66857 17.6216 5.55093C15.6602 5.96527 14.1967 6.56832 13.8301 6.72365Z",
      fill: "#00A650"
    })]
  });
};
const renderPillStyles = _ref2 => {
  let {
    text,
    text_color,
    background
  } = _ref2;
  if (!text) return {};
  return {
    color: text_color,
    background
  };
};
const DoDPill = _ref3 => {
  let {
    background,
    text_color,
    icon_id,
    text,
    isMobile
  } = _ref3;
  const styles = {
    text,
    background,
    text_color
  };
  const namespace = isMobile ? `${mainNamespaceMobile}-dod-pill` : `${mainNamespaceDesktop}-dod-pill`;
  const sizeIcon = {
    width: '18px',
    height: '11px'
  };
  return jsxs("span", {
    className: clsx(namespace),
    style: renderPillStyles(styles),
    children: [jsx("span", {
      className: clsx(`${namespace}__icon`),
      children: text && icon_id && jsx(IconMeliChoice, {
        className: clsx(namespace),
        size: sizeIcon
      })
    }), jsx("span", {
      className: clsx(`${namespace}__text`),
      children: text
    })]
  });
};
const Item = props => {
  const {
    image,
    title,
    subtitle,
    attributes,
    price,
    lowEnd,
    isMobile,
    url,
    dod,
    button
  } = props;
  const namespace = isMobile ? `${mainNamespaceMobile}-item` : `${mainNamespaceDesktop}-item`;
  return jsxs("div", {
    className: namespace,
    children: [jsx("a", {
      href: url,
      className: `${namespace}__clickable`,
      children: jsx("div", {
        className: `${namespace}__image-container`,
        children: jsx(Image, {
          className: `${namespace}__image`,
          preload: true,
          src: image.src,
          alt: title,
          lowEnd: lowEnd,
          lazyload: 'off'
        })
      })
    }), jsxs(Card, {
      paddingSize: '0',
      className: `${namespace}__text-card`,
      children: [jsx("div", {
        className: `${namespace}__dod`,
        children: dod && jsx(DoDPill, _objectSpread({
          isMobile: isMobile
        }, dod))
      }), jsxs(CardContent, {
        className: clsx(`${namespace}__text-card-content`),
        children: [jsxs("div", {
          className: `${namespace}__text-card-content__left`,
          children: [jsx(Typography, {
            className: `${namespace}__text-card-content__left-item`,
            component: 'h3',
            size: 'm',
            weight: 'semibold',
            children: title
          }), jsx(Typography, {
            className: `${namespace}__text-card-content__left-item`,
            size: isMobile ? 'xs' : 's',
            color: 'secondary',
            children: subtitle
          }), jsx(Typography, {
            className: `${namespace}__text-card-content__left-item`,
            size: 'xs',
            children: attributes
          })]
        }), jsxs("div", {
          className: `${namespace}__text-card-content__right`,
          children: [jsx(MoneyAmount, {
            className: `${namespace}__text-card__price`,
            amount: price,
            size: isMobile ? 18 : 24
          }), !isMobile && (button === null || button === void 0 ? void 0 : button.text) && jsx(Button, {
            type: 'button',
            hierarchy: 'loud',
            size: 'small',
            href: url,
            children: button === null || button === void 0 ? void 0 : button.text
          })]
        })]
      })]
    })]
  });
};
const namespace$4 = `${mainNamespaceMobile}-carousel`;
const Carousel$1 = props => {
  const {
    lowEnd,
    items
  } = props;
  return jsx("div", {
    className: namespace$4,
    children: jsx(CarouselFree, {
      "aria-label": '',
      className: `${namespace$4}__free`,
      children: items.map(item => jsx(CarouselFreeSlide, {
        children: jsx(Item, _objectSpread(_objectSpread({
          lowEnd: lowEnd
        }, item), {}, {
          isMobile: true
        }))
      }, item.id))
    })
  });
};
const namespace$3 = mainNamespaceMobile;
const BrandWrapperShowroomMobile = props => {
  const {
    content,
    items,
    lowEnd
  } = props;
  return jsx(Card, {
    paddingSize: "0",
    className: namespace$3,
    children: jsxs(CardContent, {
      children: [jsx(Hero$1, _objectSpread(_objectSpread({}, content), {}, {
        lowEnd: lowEnd
      })), jsx(Carousel$1, {
        items: items,
        lowEnd: lowEnd
      }), jsx(Footer, _objectSpread({}, content))]
    })
  });
};
BrandWrapperShowroomMobile.displayName = 'BrandWrapperShowroomMobile';
const namespace$2 = `${mainNamespaceDesktop}-hero`;
const Hero = props => {
  const {
    items,
    lowEnd
  } = props;
  const [{
    event_tracking: {
      click
    },
    content: {
      images,
      texts
    }
  }] = items;
  const [url] = click;
  return jsxs("div", {
    className: namespace$2,
    children: [jsx("a", {
      href: url.url,
      className: `${namespace$2}-clickable`,
      children: jsx("div", {
        className: `${namespace$2}-main-logo-container`,
        children: jsx(Image, {
          className: `${namespace$2}-main-logo`,
          preload: true,
          src: images.primary_logo,
          alt: texts.primary_title || 'Logo',
          lowEnd: lowEnd,
          lazyload: 'on',
          width: 120,
          height: 120
        })
      })
    }), jsxs("div", {
      className: `${namespace$2}-section-text`,
      children: [jsx(Typography, {
        className: `${namespace$2}-section-text-promoted-typography`,
        color: "secondary",
        size: 's',
        component: "h2",
        children: texts.promoted
      }), jsx(Typography, {
        size: 'l',
        component: "h3",
        className: `${namespace$2}-section-text-primary-title`,
        children: texts.primary_title
      }), jsx(BrandCta, _objectSpread(_objectSpread({}, props), {}, {
        className: `${namespace$2}-brand-cta`
      }))]
    })]
  });
};
const namespace$1 = `${mainNamespaceDesktop}-carousel`;
const Carousel = props => {
  const {
    lowEnd,
    items
  } = props;
  return jsx("div", {
    className: `${namespace$1}`,
    children: jsx(CarouselSnapped, {
      className: `${namespace$1}__container`,
      arrows: true,
      arrowsSize: "small",
      pagination: false,
      strictBoundaries: false,
      infinite: true,
      children: items.map(item => jsx(CarouselSnappedSlide, {
        className: `${namespace$1}__slide`,
        children: jsx(Item, _objectSpread({
          lowEnd: lowEnd
        }, item))
      }, item.id))
    })
  });
};
const namespace = mainNamespaceDesktop;
const BrandWrapperVISDesktop = props => {
  const {
    content,
    items,
    lowEnd
  } = props;
  return jsx(Card, {
    paddingSize: "0",
    className: namespace,
    children: jsxs(CardContent, {
      className: `${namespace}__container`,
      children: [jsx("div", {
        className: `${namespace}__container-left`,
        children: jsx(Hero, _objectSpread(_objectSpread({}, content), {}, {
          lowEnd: lowEnd
        }))
      }), jsx("div", {
        className: `${namespace}__container-right`,
        children: jsx(Carousel, {
          lowEnd: lowEnd,
          items: items
        })
      })]
    })
  });
};
BrandWrapperVISDesktop.displayName = 'BrandWrapperVISDesktop';

/* eslint-disable security/detect-unsafe-regex */
const saniticePrice = price => {
  const thousandSeparator = price.currency_id === 'MXN' ? ',' : '.';
  const [amount, cents] = String(price.amount).split('.');
  const fraction = amount.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  return {
    currencyId: price.currency_id,
    symbol: price.symbol,
    fraction,
    cents
  };
};
const saniticeItems = items => items.map(item => _objectSpread(_objectSpread({}, item), {}, {
  image: {
    src: item.picture
  },
  price: item.price && saniticePrice(item.price),
  url: item.event_tracking.click[0].url
}));
const validateBaseProps = content => {
  var _content$items;
  if ((content === null || content === void 0 || (_content$items = content.items) === null || _content$items === void 0 ? void 0 : _content$items.length) > 0) {
    var _item$event_tracking, _item$event_tracking2;
    const [item] = content.items;
    if (item.content && ((_item$event_tracking = item.event_tracking) === null || _item$event_tracking === void 0 || (_item$event_tracking = _item$event_tracking.click) === null || _item$event_tracking === void 0 ? void 0 : _item$event_tracking.length) > 0 && ((_item$event_tracking2 = item.event_tracking) === null || _item$event_tracking2 === void 0 || (_item$event_tracking2 = _item$event_tracking2.print) === null || _item$event_tracking2 === void 0 ? void 0 : _item$event_tracking2.length) > 0) {
      const [{
        url: heroUrl
      }] = item.event_tracking.click;
      const [{
        url: printUrl
      }] = item.event_tracking.print;
      const {
        images,
        texts,
        marketplace_items: marketplaceItems
      } = item.content;
      return !(images && texts && heroUrl && printUrl && (marketplaceItems === null || marketplaceItems === void 0 ? void 0 : marketplaceItems.length) > 0);
    }
  }
  return true;
};
const isContentWithFastLoading = content => 'fast_loading' in content;
const modifiedContent = content => isContentWithFastLoading(content) ? {
  items: content.fast_loading.items
} : content;
const VIEWABILITY_ENABLED = 'viewability-enabled';
const VIEWABILITY_BREAKING_CHANGES_VERSION = '1.0.0';
const isViewabilityLegacy = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.version) !== VIEWABILITY_BREAKING_CHANGES_VERSION;
const isViewabilityLoaded = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.getNonceToken()) !== '';
const useViewability = (ref, viewUrl, isPreview) => {
  const startViewabilitySession = () => {
    var _window$viewability;
    const session = (_window$viewability = window.viewability) === null || _window$viewability === void 0 ? void 0 : _window$viewability.addSession();
    session === null || session === void 0 || session.setMeliVaTrackUrl(viewUrl);
    session === null || session === void 0 || session.start(ref === null || ref === void 0 ? void 0 : ref.current);
  };
  useEffect(() => {
    if (isPreview || !viewUrl || !ref) {
      return () => null;
    }
    if (isViewabilityLegacy(window.viewability)) {
      var _window$viewability2;
      (_window$viewability2 = window.viewability) === null || _window$viewability2 === void 0 || _window$viewability2.addSession(ref.current, viewUrl);
      return () => null;
    }
    if (isViewabilityLoaded(window.viewability)) {
      startViewabilitySession();
      return () => null;
    }
    window.addEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    return () => {
      window.removeEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    };
  }, [ref, viewUrl, isPreview]);
};
const WrapperBase = props => {
  var _ref4;
  const {
    content,
    isMobile,
    lowEnd
  } = props;
  const newContent = modifiedContent(content);
  if (validateBaseProps(newContent)) {
    return null;
  }
  const ref = useRef(null);
  const [{
    content: itemContent,
    event_tracking: {
      print,
      view
    }
  }] = newContent.items;
  const [{
    url: printUrl
  }] = print;
  const viewUrl = view ? (_ref4 = [...view]) === null || _ref4 === void 0 || (_ref4 = _ref4.shift()) === null || _ref4 === void 0 ? void 0 : _ref4.url : null;
  const Component = isMobile ? BrandWrapperShowroomMobile : BrandWrapperVISDesktop;
  useViewability(ref, viewUrl);
  return jsxs("div", {
    ref: ref,
    children: [jsx(Component, {
      items: saniticeItems(itemContent.marketplace_items),
      content: newContent,
      lowEnd: lowEnd
    }), printUrl && jsx(ScriptPrint, {
      url: printUrl
    })]
  });
};
export { WrapperBase };
